export default {
    listagem: {
        titulo_pagina: 'Complements List',
        novo: 'Create New Complement',
        habilitado: 'Able',
        desabilitado: 'Disabled',
        table: {
            empty: 'No Complements Found',
            nome: 'Name',
            codigo: 'Code',
            editar: 'Edit'
        }
    },
    form: {
        titulo_pagina: {
            criar: 'Create New Complement',
            editar: 'Edit Complement'
        },
        fields: {
            codigo: {
                label: 'Code',
                description: 'Complement Code'
            },
            nome: {
                label: 'Name',
                description: 'Complement Name'
            },
            status: {
                label: 'Status',
                description: 'Complement active or inactive status'
            },
            botao_salvar : 'Save Complement'
        },
        create: {
            success: 'Complement created successfully!',
            error: 'Error creating complement!'
        },
        update: {
            success: 'Complement successfully edited!',
            error: 'Error editing complement!'
        }
    }
}
